import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articleCards } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function ArticlesList() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 md:pt-28">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto pb-20">
          <nav className="flex items-center gap-2 text-sm mb-8">
            <Link to="/" className="text-warm-500 hover:text-brand-600 transition-colors">{t('breadcrumb.home')}</Link>
            <i className="ri-arrow-right-s-line text-warm-400 text-xs" />
            <span className="text-warm-700">{t('nav.articles')}</span>
          </nav>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-warm-900 mb-4">
            {t('nav.articles')}
          </h1>
          <p className="text-warm-500 text-sm md:text-base mb-10 max-w-2xl">
            Artigos, guias e recursos sobre CSSBuy Spreadsheet para ajudar voce a pesquisar, comparar e comprar com seguranca.
          </p>

          <div className="grid gap-4">
            {articleCards.map((article) => (
              <Link
                key={article.slug}
                to={article.href}
                className="group block bg-white rounded-xl border border-warm-200 overflow-hidden hover:border-brand-200 transition-all duration-300 hover:shadow-sm sm:flex"
              >
                <div className="sm:w-56 sm:flex-shrink-0 aspect-[16/9] sm:aspect-auto sm:h-full overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={t(article.titleKey)}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 md:p-6 flex-1">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-warm-900 mb-2 group-hover:text-brand-600 transition-colors">
                    {t(article.titleKey)}
                  </h3>
                  <p className="text-sm text-warm-500 leading-relaxed mb-3">
                    {t(article.descKey)}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-warm-400">
                    <span>{article.readTime} {t('general.readTime')}</span>
                    <span>•</span>
                    <span>{t('general.lastUpdated')}: {article.lastUpdated}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}